import React from "react";
import { cn } from "../../../lib/utils";
import { FOCUS_RING } from "./classes";

/**
 * A single-choice row of chips (timeline "All · Emails · Purchases · Sessions · Notes").
 * The selected chip is filled ink, the others outlined — the admin filter tabs (BookingsAdmin).
 * `options`: `[{key, label, testId?}]`.
 */
export default function FilterChips({ options, value, onChange, label }) {
  return (
    <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-2">
      {options.map((o) => {
        const on = o.key === value;
        return (
          <button key={o.key} type="button" role="radio" aria-checked={on} onClick={() => onChange(o.key)} data-testid={o.testId}
            className={cn(
              "rounded-full px-3 py-1 text-xs transition-colors", FOCUS_RING,
              on ? "bg-eh-ink text-eh-bg border border-eh-ink" : "border border-eh-border-soft bg-white text-eh-ink hover:bg-eh-bg",
            )}>
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
